"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAssetUploadedBodyToJSON = exports.CreateAssetUploadedBodyFromJSONTyped = exports.CreateAssetUploadedBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function CreateAssetUploadedBodyFromJSON(json) {
    return CreateAssetUploadedBodyFromJSONTyped(json, false);
}
exports.CreateAssetUploadedBodyFromJSON = CreateAssetUploadedBodyFromJSON;
function CreateAssetUploadedBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fileName': json['fileName'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
    };
}
exports.CreateAssetUploadedBodyFromJSONTyped = CreateAssetUploadedBodyFromJSONTyped;
function CreateAssetUploadedBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileName': value.fileName,
        'name': value.name,
        'description': value.description,
    };
}
exports.CreateAssetUploadedBodyToJSON = CreateAssetUploadedBodyToJSON;
